import {
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from "@mui/material"
import React from "react"

const CustomTable = styled(Table)(({ theme }) => ({
  backgroundColor: theme.palette.background.main,
  borderCollapse: "collapse !important",
  "& .MuiTableCell-root": {
    padding: "12px 24px 12px 0px",
    backgroundColor: theme.palette.background.main,
    borderBottom: "none",
    boxSizing: "border-box",
    "&:last-child": {
      paddingRight: 0
    }
  },
  "& .MuiTableRow-root": {
    borderBottom: `2px solid ${theme.palette.background.default}`,
    "&:last-child": {
      borderBottom: "none"
    },
    "&:nth-last-of-type(2)": {
      borderBottom: "none"
    }
  },
  "& .MuiTableCell-head": {
    verticalAlign: "bottom",
    position: "relative",
    "&:last-child": {
      paddingRight: 0
    }
  }
}))

const TableFooter = styled(TableRow)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  borderRadius: 6,
  marginBottom: 10,
  "& .MuiTableCell-root": {
    backgroundColor: "transparent",
    "&:first-of-type": {
      borderTopLeftRadius: 6,
      borderBottomLeftRadius: 6
    },
    "&:last-child": {
      borderTopRightRadius: 6,
      borderBottomRightRadius: 6
    }
  }
}))
const GMAdditionalInfoTable = ({ columns = [], rows = [] }) => {
  return (
    <Paper sx={{ width: "100%", overflow: "hidden" }}>
      <TableContainer>
        <CustomTable stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}>
                  <Typography variant="body2Regular" style={{ opacity: 0.6 }}>
                    {column.label}
                  </Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => {
              return (
                <TableRow key={row.id}>
                  <TableCell>
                    <Typography variant="body2Regular">{row.employeeClass}</Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography variant="body2Regular">{row.percentGoal + "%"}</Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography variant="body2Regular">{row.employees}</Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography variant="body2Regular">{row.invites}</Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography variant="body2Regular">{row.nonWcmGuests}</Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography variant="body2Regular">{row.inviteRate + "%"}</Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography variant="body2Regular">{row.employeeClassInvites}</Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography variant="body2Regular">{row.employeeClassGroupNonWcm}</Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography variant="body2Regular">
                      {row.employeeClassBenchmark + "%"}
                    </Typography>
                  </TableCell>
                </TableRow>
              )
            })}
            <TableFooter>
              <TableCell />
              <TableCell />
              <TableCell align="center">
                <Typography variant="body2Regular">
                  {rows.reduce((prev, el) => prev + el.employees, 0)}
                </Typography>
              </TableCell>
              <TableCell align="center">
                <Typography variant="body2Regular">
                  {rows.reduce((prev, el) => prev + el.invites, 0)}
                </Typography>
              </TableCell>
              <TableCell align="center">
                <Typography variant="body2Regular">
                  {rows.reduce((prev, el) => prev + el.nonWcmGuests, 0)}
                </Typography>
              </TableCell>
              <TableCell />
              <TableCell align="center">
                <Typography variant="body2Regular">
                  {rows.reduce((prev, el) => prev + el.employeeClassInvites, 0)}
                </Typography>
              </TableCell>
              <TableCell />
              <TableCell />
            </TableFooter>
          </TableBody>
        </CustomTable>
      </TableContainer>
    </Paper>
  )
}

export default GMAdditionalInfoTable
